var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.597168,
    width: 21.5833,
    height: 21.5833,
    rx: 10.7917,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3367 13.6325L13.9952 12.2938C13.5161 11.8157 12.7016 12.007 12.5099 12.6285C12.3662 13.0588 11.8871 13.2979 11.4559 13.2022C10.4977 12.9632 9.20412 11.7201 8.96457 10.7161C8.82084 10.2858 9.1083 9.80772 9.53949 9.66431C10.1623 9.47307 10.354 8.6603 9.87487 8.1822L8.53338 6.84353C8.15009 6.50886 7.57517 6.50886 7.23979 6.84353L6.3295 7.75192C5.4192 8.70811 6.42532 11.242 8.67711 13.4891C10.9289 15.7361 13.4681 16.788 14.4264 15.8318L15.3367 14.9234C15.672 14.5409 15.672 13.9672 15.3367 13.6325Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.271bdbed8ab2c57e332a6a67d3899ccd.svg";
export { ForwardRef as ReactComponent };